import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AirplaneRightIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AirplaneRightGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.2656 13.4088C21.7821 13.1135 22.0898 12.5833 22.0898 11.9889L22.0898 11.9791C22.0861 11.3809 21.7722 10.8502 21.2495 10.5586L20.1608 9.95242C19.7678 9.73492 19.3242 9.61999 18.8781 9.61999L14.1896 9.61999L11.9677 3.72606C11.8751 3.47953 11.639 3.31641 11.3758 3.31641L8.98709 3.31641C8.80173 3.31641 8.62502 3.39796 8.50515 3.53946C8.38405 3.68096 8.3272 3.86818 8.36304 4.05107L9.27132 9.62001H6.29191L5.15996 8.04257C5.04133 7.87697 4.84978 7.77873 4.64588 7.77873H2.72305C2.52409 7.77873 2.33626 7.87265 2.21639 8.03206C2.09652 8.19148 2.06192 8.39846 2.11505 8.58877L3.09748 11.9544L2.11383 15.4157C2.05945 15.6066 2.099 15.8112 2.21763 15.9699C2.33749 16.1281 2.52409 16.2214 2.72305 16.2214H4.64588C4.85226 16.2214 5.04503 16.1207 5.16367 15.952L6.2672 14.3801H9.2466L8.3618 19.9522C8.33585 20.1388 8.38529 20.3217 8.50639 20.4625C8.62625 20.6034 8.80173 20.6844 8.98709 20.6844H11.3758C11.6403 20.6844 11.8775 20.5194 11.969 20.2704L14.1402 14.3801H18.8657C19.3254 14.3801 19.779 14.2596 20.1757 14.0316L21.2656 13.4088Z"
        fill="#696969"
      />
    </svg>
  );
};

export default AirplaneRightIcon;
